<template>
    <Transition name="fade">
        <AdoptionManage v-if="isAdoptionManage" :isAdoptionManage="isAdoptionManage" :adoptionID="adoptionID" :toggleManage="toggleManage" :manageMode="manageMode"/>
    </Transition>
    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0 border-bottom">
                        <div class="row">
                            <div class="col-md-4">
                                <span class="mb-0" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767"><i class="fas fa-door-open onmaum-text-pet"></i> 입양 현황 관리</span>
                            </div>
                            <div class="col-md-1">
            
                            </div>
                            <div class="col-md-2">

                            </div>
                            <div class="col-md-1 onmaum-text-right">
                                <i class="far fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="!this.$store.state.hondi.isFavorite" @click="setFavor();"></i><!-- 미선택 -->
                                <i class="fas fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="this.$store.state.hondi.isFavorite" @click="setFavor();"></i><!-- 선택 -->
                            </div>
                            <div class="col-md-2 text-center">
                                <input type="text" class="form-control" placeholder="검색어 입력" @keydown.enter="search($event.target.value)"/>
                            </div>
                            <div class="col-md-2 text-center">
                                <button class="btn btn-onmaum btn-sm ms-auto w-100" @click="goManage('insert', 0)">추가</button>
                            </div>
                            <div class="col-12">
                                <div class="onmaum-alert onmaum-alert-alarm" role="alert">
                                    <ul>
                                        <li>즐겨찾기(별모양) 체크된 아이들이 '입양해주세요'에 노출되는 아이들입니다.</li>
                                        <li>수정 시 사이트에 바로 적용됨</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-6 g-4 g-sm-4 g-md-4 g-lg-3 p-0 m-0 justify-content-center onmaum-h-60-v onmaum-overflow onmaum-overflow-type02">



                            <!-- <div class="card col p-0 mx-3 onmaum-shadow-default-none-cursor" v-for="(pet, i) in Array(2)" :key="i">
                                <div class="card-header p-0 overflow-hidden onmaum-text-opacity" style="aspect-ratio: 1/1;" @click="goManage('select', 1);">
                                    <img :src="'/img/icons/logo_icon.png'" style="width: 100%; height: 100%;" />
                                </div>
                                <div class="card-body p-0 m-0 text-center">
                                    <div class="fs-5 fw-bold">
                                        이름<span class="fs-6">, 품종</span>
                                    </div>
                                    <div class="fs-6 fw-light">
                                        생년월일, 성별
                                    </div>
                                    <div class="fs-6 fw-normal">
                                        입양여부, 중성화여부
                                    </div>
                                </div>
                            </div> -->

                            <div class="card col p-0 mx-3 onmaum-shadow-default-none-cursor" v-for="(pet, i) in petAdoptInfo" :key="i">
                                <div class="card-header p-0 overflow-hidden onmaum-text-opacity" style="aspect-ratio: 1/1;" @click="goManage('select', pet._id);">
                                    <img :src="pet.petImage[0]?pet.petImage[0].location:'/img/icons/logo_icon.png'" style="width: 100%; height: 100%;" />
                                </div>
                                <div class="card-body p-0 m-0 text-center">
                                    <div class="fs-5 fw-bold">
                                        {{ pet.petName }}<span class="fs-6" v-if="pet.petName && pet.petBreed">, </span><span class="fs-6">{{ pet.petBreed }}</span>
                                    </div>
                                    <div class="fs-6 fw-light">
                                        {{ pet.petBirth }}<span v-if="pet.petBirth && pet.petGender">, </span><span>{{ pet.petGender == '0'?'수컷':pet.petGender == '1'?'암컷':'' }}</span>
                                    </div>
                                    <div class="fs-6 fw-normal">
                                        <span class="badge bg-success onmaum-font-0_5rem me-1" v-if="pet.petAdopt??false">입양</span>
                                        <span class="badge bg-primary onmaum-font-0_5rem me-1" v-if="pet.petNeutral??false">중성화</span>
                                        <span class="badge onmaum-badge-sns onmaum-font-0_5rem me-1" v-if="pet.petTreat??false">치료함</span>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdoptionManage from './AdoptionManage.vue'

export default {
    name: 'AdoptionInfo',

    data() {
        return {
            isAdoptionManage: false,
            adoptionID: 0,
            manageMode: 'select',
            searchText: '',
        }
    },

    components:{
        AdoptionManage,
    },

    computed: {
        petAdoptInfo() {
            return this.$store.getters.getPetAdoptInfo;
        }
    },

    methods: {
        goManage(mode, id){
            this.isAdoptionManage = true;
            this.adoptionID = id;
            this.manageMode = mode;
        },

        toggleManage(){
            this.isAdoptionManage = !this.isAdoptionManage;
        },

        //검색
        search(text){
            this.$store.state.hondi.searchText = text;
        },

        //즐겨찾기 보기 설정
        setFavor(){
            this.$store.state.hondi.isFavorite = !this.$store.state.hondi.isFavorite;
        },

        //휴대전화 포맷
        setPhoneNum(a){
            let temp = a.replaceAll('-', '');

            if(temp.length == 11){
                return temp.toString().replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
            }else if(temp.length == 10 && temp.substring(0, 2) == '02'){
                return temp.toString().replace(/^(\d{2})(\d{4})(\d{4})$/, '$1-$2-$3');
            }else if(temp.length == 10 && temp.substring(0, 2) != '02'){
                return temp.toString().replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
            }else{
                return temp.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-');
            }
        },
    },

    mounted() {

        this.$store.dispatch('getAdoptInfo');

    }
}
</script>

<style>

</style>